import React from 'react';
import { BaseProductCard, Divider } from '@sparknz/spark-pattern-library';
import { trackCustomLink } from '@sparknz/tracking';

import { PlanOptionsQuery$data } from '__generated__/PlanOptionsQuery.graphql';
import {
  PlanCardKeyConditionSection,
  PlanCardMiddleSection,
  PlanCardTopSection,
} from './components';
import { getMarketingTag } from './utils/planCard.utils';

type PlanOfferDetails =
  PlanOptionsQuery$data['relatedPlans']['bundles'][0]['offerDetails'][0];

interface PlanCardProps extends PlanOfferDetails {
  badgeLabel?: string;
  onInfoIconClick?: (contentKey?: string) => void;
  PlanCardAction?: React.ReactNode;
  keepMarketingTabHeight?: boolean;
}

const PlanCard = ({
  id,
  badgeLabel,
  contentKey,
  description,
  entitlements,
  keepMarketingTabHeight = true,
  name,
  onInfoIconClick,
  PlanCardAction,
  price,
  promotions,
}: PlanCardProps) => {
  const marketingTag = badgeLabel ? null : getMarketingTag(promotions);

  const handleKeyConditionsClick = (customLink: string) => {
    if (contentKey && onInfoIconClick) {
      onInfoIconClick(contentKey);

      trackCustomLink(customLink);
    }
  };

  const handleInfoIconClick = (infoContentKey: string, customLink?: string) => {
    if (!infoContentKey || !onInfoIconClick) {
      return null;
    }
    return () => {
      onInfoIconClick(infoContentKey);

      if (customLink) {
        trackCustomLink(customLink);
      }
    };
  };

  return (
    <BaseProductCard
      keepMarketingTabHeight={keepMarketingTabHeight}
      marketingMessage={marketingTag}
      dynamicTargetValue={id}
    >
      <div data-testid="selected-plan">
        <PlanCardTopSection
          badgeLabel={badgeLabel}
          description={description}
          entitlements={entitlements}
          name={name}
          handleInfoIconClick={handleInfoIconClick}
          price={price}
          promotions={promotions}
        />
        <Divider />
        <PlanCardMiddleSection
          id={id}
          handleInfoIconClick={handleInfoIconClick}
          promotions={promotions}
        />

        {contentKey ? (
          <PlanCardKeyConditionSection
            handleKeyConditionsClick={handleKeyConditionsClick}
          />
        ) : null}

        {PlanCardAction ? (
          <>
            <Divider />
            {PlanCardAction}
          </>
        ) : null}
      </div>
    </BaseProductCard>
  );
};

export default PlanCard;
